// модуль для ленивой загрузки изображений в рубрикаторе

app.modules.imagesLazyLoad = (function (self) {
  const OPTIONS = {
    root: null,
    rootMargin: app.config.isMobile ? '50px' : '0px',
    threshold: 0,
  };

  const _observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target;
        const image = target.querySelector('.js-lazy-load-image');

        target.classList.remove('js-lazy-load-item');
        image.src = image.dataset.src;
        observer.unobserve(target);
      }
    });
  }, OPTIONS);

  const _init = () => {
    const _rubrics = document.querySelectorAll('.js-lazy-load-item');
    _rubrics?.forEach((rubric) => _observer.observe(rubric));
  };

  self.load = _init;
  return self;
})(app.modules.imagesLazyLoad || {});
